let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lV598")).then(() => parcelRequire('8N0Ia'));